// Window event names shared by api.js and authSync.js (kept in their own
// module so the two never import each other).
export const AUTH_CHANGED_EVENT = 'zaynic:auth-changed';
export const AUTH_CHECK_EVENT = 'zaynic:auth-check';
export const APP_TOAST_EVENT = 'zaynic:toast';

export function dispatchAppEvent(name, detail) {
  try {
    window.dispatchEvent(new CustomEvent(name, { detail }));
  } catch (e) {
    /* no-op (very old browsers / tests) */
  }
}

/** User id (JWT `sub`) inside an access token, or null if unreadable. */
export function tokenUserId(token) {
  try {
    const part = String(token || '').split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    const sub = JSON.parse(json).sub;
    const id = Number(sub);
    return Number.isFinite(id) ? id : null;
  } catch (e) {
    return null;
  }
}

export function readStoredUser() {
  try {
    const raw = localStorage.getItem('user_data');
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}
